import React from 'react';
import PropTypes from 'prop-types';
import { Column, Typography } from '@tempmee/react';
import { interpolatePrompt } from '../../../../domain/Awards';

/**
 * A submitted form rendered as question/answer pairs.
 *
 * The question comes from the response rather than from a label held here on
 * purpose: each answer arrives paired with the exact wording that person was
 * served, and the application and review copy has already changed once. A
 * hardcoded label would quietly re-caption an older submission with today's
 * question (GOTU-7392).
 *
 * `answerType` rides along on review answers, but every type is displayed the
 * same way — the prompt says "on a scale of 1-5", so a bare "4" reads correctly
 * underneath it, and inventing a scale maximum here would be the screen making
 * up a fact the response never sent.
 */
export const MemberAnswerList = ({ answers, applicantName }) => (
  <Column gap={4}>
    {answers.map((answer) => (
      <Column key={answer.key} gap={1}>
        <Typography variant="body2" bold className="text-text-secondary">
          {interpolatePrompt(answer.prompt, applicantName)}
        </Typography>
        <Typography variant="body1">{answer.answer}</Typography>
      </Column>
    ))}
  </Column>
);

MemberAnswerList.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      prompt: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    }),
  ).isRequired,
  /**
   * The member the form is about. Substituted into the review form's `{NAME}`
   * prompts; unused by the application form, whose prompts carry no token.
   */
  applicantName: PropTypes.string,
};

MemberAnswerList.defaultProps = {
  applicantName: '',
};
